import React from 'react';
import { AnimatePresence } from 'motion/react';
import { RadioFieldLayout } from '../../layouts/radio-field-layout.component';
import type { BasicFormFieldProps } from '../../layouts/types';
import { RadioCardOption } from './radio-card-option.component';
import { RadioCardStyles } from './radio-card.styles';

type Props = Omit<BasicFormFieldProps<'radio'>, 'label'> & {
  children: Array<React.ReactNode | null>;
  label?: string;
  animate?: boolean;
};

export const RadioCardField = ({ children, ...rest }: Props) => {
  const radioFieldStyles = RadioCardStyles.radioCardField;

  const content = (
    <RadioFieldLayout {...rest}>
      <div className={radioFieldStyles}>{children}</div>
    </RadioFieldLayout>
  );

  return rest.animate ? <AnimatePresence>{content}</AnimatePresence> : content;
};

RadioCardField.Option = RadioCardOption;
